//สำหรับ redirect เมื่อผิดเงื่อนใข
var authRoutes = {
    // 5: {
    //     //==>> 5 : Supervisor <<==
    //     forNoLogin: "/pages/login",
    //     forNoGuest: "/dashboards/telesurvey/survey",
    // },
    // 6: {
    //     //==>> 6 : Agent <<==
    //     forNoLogin: "/pages/login",
    //     forNoGuest: "/dashboards/telesurvey/survey",
    // },
    // 9: {
    //     //==>> 9 : QC <<==
    //     forNoLogin: "/pages/login",
    //     forNoGuest: "/dashboards/QCTelesurvey/qcCheck/pr/check",
    // },
    default: {
        forNoLogin: "/pages/login",
        forNoGuest: "/dashboards/SendSMS",
    }
}
export default authRoutes;
